import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
  Container
} from "@mui/material";
import useAuthenticatedFetch from '../hooks/useAuthenticatedFetch';
import { useAuth } from '../AuthContext'; // Importer le contexte
import { useNavigate } from "react-router-dom";

const AdminSettings = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [users, setUsers] = useState([]);
  const [communities, setCommunities] = useState([]);
  const { user } = useAuth(); // Accéder à l'état global
  const fetchWithAuth = useAuthenticatedFetch();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Utilisateur dans AdminSetting :", user);
  }, [user]);

  // Redirection si l'utilisateur n'est pas connecté
  useEffect(() => {
    if (!user.userId) {
      navigate("/"); // Rediriger vers la page d'accueil
    }
  }, [user, navigate]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Charger les utilisateurs
  useEffect(() => {
    if (selectedTab === 0) {
      fetchWithAuth(`${process.env.REACT_APP_BASE_URL}/admin/getUsers`)
        .then((res) => res.json())
        .then((data) => setUsers(data))
        .catch((err) => console.error("Erreur lors de la récupération des utilisateurs :", err));
    }
  }, [user, selectedTab, fetchWithAuth]);

  // Charger les communautés
  useEffect(() => {
    if (selectedTab === 1) {
      fetchWithAuth(`${process.env.REACT_APP_BASE_URL}/admin/getCommunities`)
        .then((res) => res.json())
        .then((data) => setCommunities(data))
        .catch((err) => console.error("Erreur lors de la récupération des communautés :", err));
    }
  }, [user, selectedTab, fetchWithAuth]);

  return (
    <Container maxWidth="lg">
      <Box mt={12}>
        {/* Menu avec les tabs */}
        <Box sx={{ display: "flex", height: "calc(100vh - 64px)" }}>
          <Box sx={{ width: "20%", backgroundColor: "grey.100", padding: 2 }}>
            <Tabs
              orientation="vertical"
              value={selectedTab}
              onChange={handleTabChange}
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              <Tab label="Users" />
              <Tab label="Communauté" />
              <Tab label="Salles" />
              <Tab label="Template" />
            </Tabs>
          </Box>

          <Box sx={{ width: "80%", padding: 3 }}>
            {/* Contenu de chaque onglet */}
            {selectedTab === 0 && (
              <Box>
                <h2>Liste des utilisateurs</h2>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Role</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {users.map((user) => (
                        <TableRow key={user.id}>
                          <TableCell>{user.id}</TableCell>
                          <TableCell>
                            <TextField
                              value={user.email}
                              onChange={(e) =>
                                setUsers((prev) =>
                                  prev.map((u) =>
                                    u.id === user.id ? { ...u, email: e.target.value } : u
                                  )
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Select
                              value={user.role}
                              onChange={(e) =>
                                setUsers((prev) =>
                                  prev.map((u) =>
                                    u.id === user.id ? { ...u, role: e.target.value } : u
                                  )
                                )
                              }
                            >
                              <MenuItem value="admin">Admin</MenuItem>
                              <MenuItem value="user">User</MenuItem>
                            </Select>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {selectedTab === 1 && (
              <Box>
                <h2>Liste des communautés</h2>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Nom</TableCell>
                        <TableCell>Contact</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {communities.map((community) => (
                        <TableRow key={community.id}>
                          <TableCell>{community.id}</TableCell>
                          <TableCell>
                            <TextField
                              value={community.name}
                              onChange={(e) =>
                                setCommunities((prev) =>
                                  prev.map((c) =>
                                    c.id === community.id ? { ...c, name: e.target.value } : c
                                  )
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={community.contact}
                              onChange={(e) =>
                                setCommunities((prev) =>
                                  prev.map((c) =>
                                    c.id === community.id ? { ...c, contact: e.target.value } : c
                                  )
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {selectedTab === 2 && <h2>Gérer les salles</h2>}
            {selectedTab === 3 && <h2>Gérer les templates</h2>}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default AdminSettings;
